<app-page-header [showHelpIcon]="true" (onOpenHelpClick)="showHelp = !showHelp" subtitle="Gebruiker"></app-page-header>
@if (showHelp) {
    <app-user-role-descriptions [roles]="roles"></app-user-role-descriptions>
}
<div class="below-navbar container-xl">
    <div class="row">
        <div class="col mb-3">
            <button mat-stroked-button routerLink="/gebruikers">
                <i class="fas fa-arrow-left me-2"></i> Terug naar gebruikers
            </button>
        </div>
    </div>

    @if (user) {
        @if (user.deleted_at) {
            <div class="row mb-3">
                <div class="col-24">
                    <div class="alert alert-danger d-flex align-items-center gap-2" role="alert">
                        <i class="fas fa-exclamation-triangle fa-2x me-3"></i>
                        <div>
                            <h4 class="alert-heading mb-1">Gebruiker is verwijderd</h4>
                            <p class="mb-0">
                                Deze gebruiker is verwijderd op
                                <strong>{{ user.deleted_at | date: 'EEEE d MMMM yyyy HH:mm' }} uur.</strong>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        }

        @if (user.enddate) {
            <div class="row mb-3">
                <div class="col-24">
                    <div class="alert alert-warning d-flex align-items-center gap-2" role="alert">
                        <i class="fas fa-exclamation-triangle fa-2x me-3"></i>
                        <div>
                            <h4 class="alert-heading mb-1">Gebruiker gaat / is uit dienst</h4>
                            <p class="mb-0">
                                Deze gebruiker gaat of is uit dienst per
                                <strong>{{ user.enddate | date: 'EEEE d MMMM yyyy HH:mm' }} uur.</strong>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        }

        @if (form) {
            <div class="row justify-content-center">
                <div class="col-24">
                    <form [formGroup]="form">
                        <div class="profile-picture-row">
                            <app-codalt-upload-image
                                class="profile-picture"
                                [fcImage]="form.controls.profile_picture"
                                [fileStorage]="FileStorage.ProfilePictures"
                                [hideControls]="true"
                                [width]="150"
                                [height]="150"
                                [resizedSize]="1200"></app-codalt-upload-image>
                            <div class="row flex-grow-1">
                                <mat-form-field class="w-100">
                                    <input
                                        [readonly]="!(Roles.Codalt | hasRole) && !isExternalUser"
                                        formControlName="name"
                                        matInput
                                        name="name"
                                        placeholder="Naam"
                                        type="text" />
                                    <mat-error>Dit veld moet minimaal 3 tekens bevatten</mat-error>
                                </mat-form-field>

                                <mat-form-field class="w-100">
                                    <input
                                        [readonly]="!(Roles.Codalt | hasRole)"
                                        formControlName="email"
                                        matInput
                                        name="email"
                                        placeholder="E-mail"
                                        type="email" />
                                    <mat-error>Vul een correct e-mailadres in</mat-error>
                                </mat-form-field>
                            </div>
                        </div>

                        <div
                            class="mt-3"
                            [class.roles]="uniqueRoles.length || (Functionalities.CodaltMode | hasFunctionality)"
                            [class.roles-with-functionalities]="
                                uniqueRoles.length && (Functionalities.CodaltMode | hasFunctionality)
                            ">
                            @if (!uniqueRoles.length) {
                                <mat-form-field class="w-100">
                                    <mat-select
                                        [multiple]="true"
                                        formControlName="regularRoles"
                                        placeholder="Gebruikersgroepen">
                                        @for (role of roles; track role.key) {
                                            <mat-option [value]="role.key">
                                                {{ role.name }}
                                                @if (hasPlannableFunctionality(role)) {
                                                    <i class="fa-regular fa-calendar ms-1" aria-hidden="true"></i>
                                                }
                                                @if (hasSettleFunctionality(role)) {
                                                    <i
                                                        class="fa-regular fa-money-check-dollar-pen ms-1"
                                                        matTooltip="Wordt verloond met de periodeverrekening"
                                                        aria-hidden="true"></i>
                                                }
                                            </mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                            } @else {
                                <div class="mb-3">
                                    <div class="mb-2 font-weight-bold">Unieke gebruikersgroep</div>
                                    <mat-radio-group formControlName="uniqueRole">
                                        @for (role of uniqueRoles; track role.key) {
                                            <mat-radio-button
                                                class="me-3"
                                                [value]="role.key"
                                                [matTooltip]="role.description"
                                                [disabled]="isUniqueRoleDisabled(role)">
                                                {{ role.name }}

                                                @if (role.is_external) {
                                                    <i class="fa fa-store-slash" aria-hidden="true"></i>
                                                }

                                                @if (hasPlannableFunctionality(role)) {
                                                    <i class="fa-regular fa-calendar ms-1" aria-hidden="true"></i>
                                                }

                                                @if (hasSettleFunctionality(role)) {
                                                    <i
                                                        class="fa-regular fa-money-check-dollar-pen ms-1"
                                                        matTooltip="Wordt verloond met de periodeverrekening"
                                                        aria-hidden="true"></i>
                                                }
                                            </mat-radio-button>
                                        }
                                    </mat-radio-group>
                                </div>

                                <div class="mb-3">
                                    <div class="mb-2 font-weight-bold">Gebruikersgroepen</div>
                                    @for (role of roles; track role.key) {
                                        <div class="checkbox-compact">
                                            <mat-checkbox
                                                [checked]="isRegularRoleChecked(role.key)"
                                                [matTooltip]="role.description"
                                                [disabled]="isRoleDisabled(role)"
                                                (change)="onRegularRoleCheckboxChange(role.key, $event.checked)"
                                                color="primary">
                                                {{ role.name }}
                                                @if (role.restricted) {
                                                    <i class="fa fa-lock" aria-hidden="true"></i>
                                                }
                                                @if (hasPlannableFunctionality(role)) {
                                                    <i class="fa-regular fa-calendar ms-1" aria-hidden="true"></i>
                                                }
                                                @if (hasSettleFunctionality(role)) {
                                                    <i
                                                        class="fa-regular fa-money-check-dollar-pen ms-1"
                                                        matTooltip="Wordt verloond met de periodeverrekening"
                                                        aria-hidden="true"></i>
                                                }
                                            </mat-checkbox>
                                        </div>
                                    }
                                    <mat-error [control]="form.get('regularRoles')"></mat-error>
                                </div>
                            }
                            @if (Functionalities.CodaltMode | hasFunctionality) {
                                <div class="functionalities mb-3">
                                    <div class="functionalities-content">
                                        <div class="mb-2 font-weight-bold">Functionaliteiten</div>
                                        <mat-form-field class="w-100" appearance="outline" subscriptSizing="dynamic">
                                            <mat-label>Filter functionaliteiten</mat-label>
                                            <input
                                                #functionalityFilterInput
                                                matInput
                                                type="search"
                                                [value]="functionalityFilter()"
                                                (input)="functionalityFilter.set(functionalityFilterInput.value)" />
                                        </mat-form-field>
                                        <div class="functionalities-list mt-2">
                                            @for (
                                                functionality of filteredUserFunctionalities();
                                                track functionality.key
                                            ) {
                                                <div class="checkbox-compact functionality-row">
                                                    <mat-checkbox
                                                        [checked]="true"
                                                        [disabled]="true"
                                                        [aria-label]="functionality.name"
                                                        color="primary">
                                                    </mat-checkbox>

                                                    <span
                                                        class="functionality-copy"
                                                        type="button"
                                                        [matTooltip]="
                                                            functionality.key +
                                                            (functionality.description
                                                                ? '\n\n' + functionality.description
                                                                : '')
                                                        "
                                                        [attr.aria-label]="'Kopieer ' + functionality.name"
                                                        (click)="copyFunctionality(functionality)">
                                                        {{ functionality.name }}
                                                    </span>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                        @if (Functionalities.UserTakeover | hasFunctionality) {
                            <div class="mt-3 mb-4">
                                <div class="mb-2 font-weight-bold">Querylogging</div>
                                <div class="d-flex flex-wrap align-items-start row-gap-2 column-gap-3">
                                    <mat-form-field appearance="outline">
                                        <mat-label>Trage queries</mat-label>
                                        <mat-select formControlName="queryLoggingSlowDuration">
                                            <mat-option value="off">Uit</mat-option>
                                            <mat-option value="1h">1 uur</mat-option>
                                            <mat-option value="1d">1 dag</mat-option>
                                            <mat-option value="1w">1 week</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <mat-form-field appearance="outline">
                                        <mat-label>Alle queries</mat-label>
                                        <mat-select formControlName="queryLoggingAllDuration">
                                            <mat-option value="off">Uit</mat-option>
                                            <mat-option value="1h">1 uur</mat-option>
                                            <mat-option value="1d">1 dag</mat-option>
                                            <mat-option value="1w">1 week</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <button
                                        type="button"
                                        mat-stroked-button
                                        color="primary"
                                        (click)="saveQueryLogging()">
                                        Querylogging opslaan
                                    </button>
                                    <button
                                        type="button"
                                        mat-stroked-button
                                        color="warn"
                                        (click)="stopAllQueryLogging()">
                                        Stop alle logging
                                    </button>
                                </div>
                                @if (queryLoggingSlowExpiresAt || queryLoggingAllExpiresAt) {
                                    <small class="text-muted d-flex flex-column gap-1 mt-1">
                                        @if (queryLoggingSlowExpiresAt) {
                                            <div>
                                                <i class="fa-regular fa-clock me-1" aria-hidden="true"></i>
                                                Trage queries worden gelogd tot
                                                {{ queryLoggingSlowExpiresAt | date: 'EEEE d MMMM yyyy HH:mm' }}.
                                            </div>
                                        }
                                        @if (queryLoggingAllExpiresAt) {
                                            <div>
                                                <i class="fa-regular fa-clock me-1" aria-hidden="true"></i>
                                                Alle queries worden gelogd tot
                                                {{ queryLoggingAllExpiresAt | date: 'EEEE d MMMM yyyy HH:mm' }}.
                                            </div>
                                        }
                                    </small>
                                }
                            </div>
                        }

                        <app-user-login-info [user]="user" />

                        <app-user-role-history [userId]="user.id" />

                        @if (Functionalities.CodaltMode | hasFunctionality) {
                            <div class="pt-3">
                                <div class="mb-2 font-weight-bold">Gebruikersgegevens</div>
                                <div class="table-responsive">
                                    <table class="table user-data w-100 mb-4">
                                        <tbody>
                                            <tr>
                                                <th colspan="2" scope="rowgroup">Account</th>
                                            </tr>
                                            <tr>
                                                <th scope="row">Microsoft-ID</th>
                                                <td>{{ user.microsoft_id ?? '-' }}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Mislukte inlogpogingen</th>
                                                <td>{{ user.login_attempts ?? '-' }}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Totaal mislukte inlogpogingen</th>
                                                <td>{{ user.total_login_attempts ?? '-' }}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Laatst ingelogd</th>
                                                <td>
                                                    {{ (user.last_login_at | date: 'EEEE d MMM yyyy HH:mm') ?? '-' }}
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody>
                                            <tr>
                                                <th colspan="2" scope="rowgroup">Contactgegevens</th>
                                            </tr>
                                            <tr>
                                                <th scope="row">Adres</th>
                                                <td>
                                                    @if (user.street || user.housenumber || user.zipcode || user.town) {
                                                        <a
                                                            [href]="userAddressMapUrl"
                                                            target="_blank"
                                                            rel="noopener noreferrer">
                                                            {{ user.street }} {{ user.housenumber }}
                                                            @if (
                                                                (user.street || user.housenumber) &&
                                                                (user.zipcode || user.town)
                                                            ) {
                                                                <br />
                                                            }
                                                            {{ user.zipcode }} {{ user.town }}
                                                        </a>
                                                    } @else {
                                                        -
                                                    }
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Telefoon</th>
                                                <td>
                                                    @if (user.phone) {
                                                        <a [href]="'tel:' + user.phone">{{ user.phone }}</a>
                                                    } @else {
                                                        -
                                                    }
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tbody>
                                            <tr>
                                                <th colspan="2" scope="rowgroup">Dienstverband</th>
                                            </tr>
                                            <tr>
                                                <th scope="row">Groep</th>
                                                <td>{{ user.group ?? '-' }}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Functie</th>
                                                <td>{{ user.function ?? '-' }}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Type dienstverband</th>
                                                <td>{{ user.employment_type ?? '-' }}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">AFAS-medewerkernummer</th>
                                                <td>{{ user.afas_employee_id ?? '-' }}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Contracturen</th>
                                                <td>{{ user.contract_hours ?? '-' }}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Begindatum</th>
                                                <td>{{ (user.begindate | date: 'EEEE d MMM yyyy') ?? '-' }}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Einddatum</th>
                                                <td>{{ (user.enddate | date: 'EEEE d MMM yyyy') ?? '-' }}</td>
                                            </tr>
                                        </tbody>
                                        <tbody>
                                            <tr>
                                                <th colspan="2" scope="rowgroup">Uren en vervoer</th>
                                            </tr>
                                            <tr>
                                                <th scope="row">Reistijd werkdagen</th>
                                                <td>{{ user.traveltime_workday ?? '-' }}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Reistijd weekend</th>
                                                <td>{{ user.traveltime_weekend ?? '-' }}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Standaard start- en eindlocatie</th>
                                                <td>{{ user.default_stand ?? '-' }}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Alleen overuren</th>
                                                <td>
                                                    {{ user.overtime == null ? '-' : user.overtime ? 'Ja' : 'Nee' }}
                                                </td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Maximum kilometers</th>
                                                <td>{{ user.maxkm ?? '-' }}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Urencontrole door medewerker</th>
                                                <td>{{ user.hours_checked_by ?? '-' }}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Urencontrole door rol</th>
                                                <td>{{ user.hours_checked_by_role ?? '-' }}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Auto-ID</th>
                                                <td>{{ user.car_id ?? '-' }}</td>
                                            </tr>
                                        </tbody>
                                        <tbody>
                                            <tr>
                                                <th colspan="2" scope="rowgroup">Registratie</th>
                                            </tr>
                                            <tr>
                                                <th scope="row">Aangemaakt op</th>
                                                <td>{{ (user.created_at | date: 'EEEE d MMM yyyy HH:mm') ?? '-' }}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Bijgewerkt op</th>
                                                <td>{{ (user.updated_at | date: 'EEEE d MMM yyyy HH:mm') ?? '-' }}</td>
                                            </tr>
                                            <tr>
                                                <th scope="row">Verwijderd op</th>
                                                <td>{{ (user.deleted_at | date: 'EEEE d MMM yyyy HH:mm') ?? '-' }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }

                        @if (!isExternalUser || user.afas_employee_id) {
                            <div class="mb-2 mt-3 font-weight-bold">Afas medewerker (#{{ user.afas_employee_id }})</div>
                            @if (employee) {
                                <table class="table table-striped">
                                    <thead>
                                        <tr>
                                            <th>Eigenschap</th>
                                            <th>Waarde</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="fw-bold">Naam</td>
                                            <td>{{ employee.birthName }}, {{ employee.firstName }}</td>
                                        </tr>
                                        <tr>
                                            <td class="fw-bold">Medewerkernummer</td>
                                            <td>#{{ employee.employeeId }}</td>
                                        </tr>
                                        <tr>
                                            <td class="fw-bold">Startdatum</td>
                                            <td>{{ employee.employmentStart | date: 'EEEE d MMMM yyyy HH:mm' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="fw-bold">Einddatum</td>
                                            <td>
                                                {{ (employee.employmentEnd | date: 'EEEE d MMMM yyyy HH:mm') ?? '-' }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="fw-bold">CodaltFunctie / Functie</td>
                                            <td>
                                                {{ employee.codaltFunctie ?? ' - ' }} /
                                                <span
                                                    [class.text-decoration-line-through]="
                                                        employee.codaltFunctie?.length > 0
                                                    ">
                                                    {{ employee.functionDesc }}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="fw-bold">Adres</td>
                                            <td>{{ locationService.formatAddress(user) || '-' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            } @else {
                                <div>
                                    <i>Niet gekoppeld aan Afas. Gebruiker aanmaken? Toevoegen in Afas!</i>
                                </div>
                            }
                        }

                        @if (!isExternalUser) {
                            <div class="row mt-3">
                                <div class="col-24 col-md-12">
                                    <mat-form-field class="w-100">
                                        <mat-label>Urencontrole door medewerker</mat-label>
                                        <mat-select formControlName="hours_checked_by" placeholder="Gebruikers">
                                            <mat-option [value]="null">Geen</mat-option>
                                            <mat-option *ngFor="let user of hourCheckUsers" [value]="user.id">
                                                {{ user.name }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error [control]="form.get('hours_checked_by')"></mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="col-24 col-md-12">
                                    <mat-form-field class="w-100">
                                        <mat-label>Urencontrole door rol</mat-label>
                                        <mat-select formControlName="hours_checked_by_role" placeholder="Rollen">
                                            <mat-option [value]="null">Geen</mat-option>
                                            <mat-option *ngFor="let role of roles" [value]="role.key">
                                                {{ role.name }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error [control]="form.get('hours_checked_by_role')"></mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <ng-select
                                class="mt-3"
                                [clearable]="true"
                                formControlName="car_id"
                                placeholder="Personenauto">
                                @for (entity of entityCars; track entity) {
                                    <ng-option [value]="entity.id">{{ entity.name }}</ng-option>
                                }
                            </ng-select>
                        }

                        @if (environment.employeeEmployees) {
                            <ng-select
                                class="mt-3"
                                [items]="users"
                                [multiple]="true"
                                [clearSearchOnAdd]="true"
                                [closeOnSelect]="false"
                                [clearable]="true"
                                formControlName="employees"
                                bindValue="id"
                                bindLabel="name"
                                placeholder="Standaard personeel">
                                <ng-template ng-option-tmp let-item="item" let-index="index">
                                    {{ item.name }} ({{ item.function }})
                                </ng-template>
                            </ng-select>
                        }

                        <div class="row mt-3 align-items-start">
                            @if (environment.defaultStand && hasPlannableRole) {
                                <div class="col-24 col-md-9">
                                    <div class="mb-2 font-weight-bold">Standaard start- en eindlocatie:</div>
                                    <mat-radio-group formControlName="default_stand">
                                        <mat-radio-button class="me-2" [value]="DefaultStand.Geen" color="primary">
                                            Geen
                                        </mat-radio-button>
                                        <mat-radio-button class="me-2" [value]="DefaultStand.Home" color="primary">
                                            Thuis
                                        </mat-radio-button>
                                        <mat-radio-button
                                            class="me-2"
                                            [value]="DefaultStand.Floridadreef"
                                            color="primary">
                                            Floridadreef
                                        </mat-radio-button>
                                    </mat-radio-group>
                                    @if (showHelp) {
                                        <div class="mb-2">
                                            <small>
                                                Deze instelling bepaald enkel de standaardlocatie bij het inplannen via
                                                transportplanning.
                                                <li>Geen: Reistijd* van thuis naar werklocatie, geen transporttijd</li>
                                                <li>Thuis: Geen reistijd*, wel transporttijd** van thuis naar werk</li>
                                                <li>
                                                    Floridadreef: reistijd* van thuis naar werklocatie, transporttijd**
                                                    van floridadreef naar werk
                                                </li>
                                                * = Indien gekozen bij profiel<br />
                                                ** = Transporttijd zit in werktijd indien geen machine gekozen waarvoor
                                                separate registratie noodzakelijk is<br />
                                            </small>
                                        </div>
                                    }
                                </div>
                            }
                            @if (environment.travelTime && hasPlannableRole) {
                                <div class="col-24 col-md-5">
                                    <div class="mb-2 font-weight-bold">Uitbetaling reistijd werkdagen:</div>
                                    <mat-radio-group formControlName="traveltime_workday">
                                        <mat-radio-button class="me-2" [value]="TraveltimeWorkday.Geen" color="primary">
                                            {{ travelTimeNameMap.get(TraveltimeWorkday.Geen) }}
                                        </mat-radio-button>
                                        <mat-radio-button
                                            class="me-2"
                                            [value]="TraveltimeWorkday.Staffel"
                                            color="primary">
                                            {{ travelTimeNameMap.get(TraveltimeWorkday.Staffel) }}
                                        </mat-radio-button>
                                        <mat-radio-button
                                            class="me-2"
                                            [value]="TraveltimeWorkday.Werkelijk"
                                            color="primary">
                                            {{ travelTimeNameMap.get(TraveltimeWorkday.Werkelijk) }}
                                        </mat-radio-button>
                                    </mat-radio-group>
                                </div>
                                <div class="col-24 col-md-5">
                                    <div class="mb-2 font-weight-bold">Uitbetaling reistijd weekend:</div>
                                    <mat-radio-group formControlName="traveltime_weekend">
                                        <mat-radio-button class="me-2" [value]="TraveltimeWeekend.Geen" color="primary">
                                            {{ travelTimeNameMap.get(TraveltimeWeekend.Geen) }}
                                        </mat-radio-button>
                                        <mat-radio-button [value]="TraveltimeWeekend.Werkelijk" color="primary">
                                            {{ travelTimeNameMap.get(TraveltimeWeekend.Werkelijk) }}
                                        </mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            }
                            @if (environment.onlyOvertime && hasPlannableRole) {
                                <div class="col-24 col-md-5">
                                    <div class="mb-2 font-weight-bold">Alleen overuren:</div>
                                    <mat-checkbox formControlName="overtime" color="primary">
                                        Uren registreren als overuren
                                    </mat-checkbox>
                                </div>
                            }
                        </div>

                        @if (hasGeoFunctionality && !(Functionalities.AccessAllCustomers | hasFunctionality: user)) {
                            <div class="mt-3">
                                <div class="mb-2 font-weight-bold">Klantgebieden</div>
                                <ng-select
                                    [items]="customers"
                                    [multiple]="true"
                                    [searchable]="true"
                                    [typeahead]="customerSearch$"
                                    [loading]="customersLoading"
                                    bindLabel="name"
                                    bindValue="id"
                                    formControlName="customers">
                                </ng-select>
                                <app-user-customer-history [userId]="user.id"></app-user-customer-history>
                            </div>
                        }

                        @if (
                            hasGeoFunctionality && (Functionalities.CustomerProjectsSubscribe | hasFunctionality: user)
                        ) {
                            <div class="mt-3">
                                <div class="mb-2 font-weight-bold">Projecten</div>
                                <p>Deze gebruiker volgt de volgende projecten van D. van der Steen B.V.:</p>
                                <table class="table w-100 mb-3">
                                    <thead>
                                        <tr>
                                            <th>Project</th>
                                            <th>Startdatum</th>
                                            <th>Einddatum</th>
                                            <th>Status</th>
                                            <th class="text-right">Acties</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        @for (
                                            customerProject of user.customer_projects_history;
                                            track customerProject.id
                                        ) {
                                            <tr>
                                                <td>{{ customerProject.name }}</td>
                                                <td>
                                                    {{
                                                        (customerProject.pivot?.created_at | date: 'EEE d MMM y') ?? '-'
                                                    }}
                                                </td>
                                                <td>
                                                    {{
                                                        (customerProject.pivot?.deleted_at | date: 'EEE d MMM y') ?? '-'
                                                    }}
                                                </td>
                                                <td>
                                                    @if (customerProject.pivot?.deleted_at) {
                                                        <span class="text-danger">Uitgeschreven</span>
                                                    } @else {
                                                        <span class="text-success">Actief</span>
                                                    }
                                                </td>
                                                <td class="text-right">
                                                    @if (!customerProject.pivot?.deleted_at) {
                                                        <button
                                                            (click)="removeTownProject(customerProject)"
                                                            color="warn"
                                                            mat-stroked-button>
                                                            Uitschrijven
                                                            <span class="d-none d-md-inline">voor project</span>
                                                        </button>
                                                    }
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                                <button class="mb-3" (click)="addTownProject()" color="primary" mat-stroked-button>
                                    Project toevoegen
                                </button>
                            </div>
                        }
                    </form>
                </div>
            </div>
        }

        @if (hasPlannableRole) {
            <app-planning-table [title]="user.name" [userId]="user.id"></app-planning-table>
        }
    }
</div>

@if (user) {
    <div class="button-wrapper">
        <div class="container">
            <div class="buttons">
                <button [disabled]="form?.invalid || saving" (click)="save()" mat-raised-button color="primary">
                    Opslaan

                    @if (saving) {
                        <i class="fas fa-circle-notch fa-spin ms-2"></i>
                    }
                </button>
            </div>
        </div>
    </div>
}
